import React,{useState,useEffect} from 'react'
import {Box } from 'grommet'
import { withRouter } from 'react-router-dom';
import EditOrgForm from '../../../components/editOrgForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,LoadLayer} from '../../../components/utils/shared/shared';
import { uploadToS3, APIRequest } from '../../../components/utils/shared/requests';

function EditOrg (props) {
  const [org, setOrg] = useState();
  const [load, setLoad] = useState(true); 
  const [documents, setDocuments] = useState()
  const handleDocsChange = (event) => {
    setDocuments(event.target.files[0])
  };
  useEffect(() => { 
    APIRequest(`/organisations/${props.match.params.org_id}`).then(result => {setOrg(result); setLoad(false)})
  },[]);
    const handleSubmit = () => {
        setLoad(true)
        if (documents != null){
          const s3Key = uploadToS3(documents)
          org.logo_key = s3Key
        }
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/organisations/${org.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{organisation: org}})
          .then(shipment => {
            setLoad(false)
            props.history.push({pathname: "/admin/organisations/all", edit:true, organisationSucc:true})
          })
        })
      }
      console.log(org)
  return (
   <Box>
      {(load ? <LoadLayer load={load} label={'Loading Organisation...'} />: 
      <Box>
        <NavigationSnackBar title={`Edit Organisation: ${org.name}`} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Organisations', link: '/organisations/all'}]}  />
        <Box alignSelf='center' elevation='medium' direction='column' margin='small' round width='xxlarge'>    
        <EditOrgForm org={org} load={load} handleSubmit={handleSubmit} setOrg={setOrg} handleDocsChange={handleDocsChange} setDocuments={setDocuments} />
        </Box>
      </Box>
      )}
   </Box>
  )
}

export default withRouter(EditOrg)
